export default "__VITE_ASSET__43742e42__"